import simone from "./assets/SIMONE.png";

export function TwilioLogo() {
  return <img width="40" height="40" src={simone} />;
}
